<div
    [checkoutCy]="'divstore-' + store.id"
    [ngClass]="{ 'is-last': isLast, 'is-highlighted is-main': isSelected, 'is-standalone': isStandAlone }"
    class="box store is-radiusless is-shadowless"
>
    <p class="has-text-weight-medium is-marginless is-lowercase text is-level-1">
        {{ store.name }}
    </p>
    <p checkoutCsMask class="text is-level-2 is-lowercase">
        <span class="icon is-small"><i class="tri-marker-solid"></i></span>
        <span>
            @if (store?.street_number) {
                <span>{{ store?.street_number }}</span>
            }
            {{ store.street }} {{ store.postalCode }} {{ store.city }}
        </span>
    </p>

    <div class="columns is-multiline is-flex is-justified-center is-aligned-center is-gapless">
        <div class="column">
            <div class="columns is-mobile is-aligned-center is-multiline">
                <div class="column is-narrow">
                    <p class="is-size-7 is-marginless">
                        <span class="icon-and-text">
                            <span class="icon is-small is-marginless">
                                <i class="tri-parcel"></i>
                            </span>
                            <span>
                                {{ store.distanceFromAdress }}
                                <abbr title="kilomètres">km</abbr>
                            </span>
                        </span>
                    </p>
                </div>
                <div class="column">
                    @if (isSelected) {
                        <div class="sticker is-small is-info">
                            <div class="icon-and-text is-justified-center has-text-weight-bold">
                                <span class="icon is-small">
                                    <i class="tri-check-circle"></i>
                                </span>
                                {{
                                    store.deliveryType === 'CLICK_COLLECT'
                                        ? 'Boutique sélectionnée'
                                        : 'Point de retrait sélectionné'
                                }}
                            </div>
                        </div>
                    } @else {
                        <button
                            (click)="selectStore()"
                            [checkoutCy]="'btnstore-' + store.id"
                            class="button is-primary"
                            [disabled]="isSelected"
                        >
                            {{
                                store.deliveryType === 'CLICK_COLLECT'
                                    ? 'Choisir cette boutique'
                                    : 'Choisir ce point de retrait'
                            }}
                        </button>
                    }
                </div>
            </div>
        </div>

        <div class="column is-12 is-12-mobile">
            <div class="hours-infos-container has-background-grey-fade column is-12 is-12-mobile mt-1">
                <a
                    (click)="showHours = !showHours"
                    class="has-cursor toggle-store-openings link has-icon is-fullwidth is-centered is-vcentered"
                >
                    <span>Voir les horaires d'ouverture</span>
                    <span [ngClass]="{ 'rotate-up': showHours }" class="icon is-small">
                        <i aria-hidden="true" class="tri-arrow-down"></i>
                    </span>
                </a>

                <div class="hours-infos" [ngClass]="{ 'is-expanded': showHours }">
                    @if (store.hours.exceptionalOpenings?.length > 0) {
                        <p>
                            <span
                                class="text is-level-2 has-text-weight-semibold"
                                [ngPlural]="store.hours.exceptionalOpenings?.length"
                            >
                                <ng-template ngPluralCase="=1">Ouverture exceptionnelle&nbsp;:</ng-template>
                                <ng-template ngPluralCase="other">Ouvertures exceptionnelles&nbsp;:</ng-template>
                            </span>
                            @for (opening of store.hours.exceptionalOpenings; track opening) {
                                <checkout-opening-hour-line
                                    [dayName]="opening.date | capitalizeFirstLetter"
                                    [dayOpeningHours]="opening.openingHours"
                                />
                            }
                        </p>
                    }

                    @if (store.hours.exceptionalClosings?.length > 0) {
                        <p>
                            <span
                                class="text is-level-2 has-text-weight-semibold"
                                [ngPlural]="store.hours.exceptionalClosings?.length"
                            >
                                <ng-template ngPluralCase="=1">Fermeture exceptionnelle&nbsp;:</ng-template>
                                <ng-template ngPluralCase="other">Fermetures exceptionnelle&nbsp;:</ng-template>
                            </span>
                            @for (closing of store.hours.exceptionalClosings; track closing) {
                                <checkout-opening-hour-line
                                    [dayName]="closing.date | capitalizeFirstLetter"
                                    dayOpeningHours="Fermé"
                                />
                            }
                        </p>
                        <div class="divider"></div>
                    }
                    @for (hour of store.hours.weekly | keyvalue; track hour) {
                        <checkout-opening-hour-line
                            [dayName]="hour.value.dayName"
                            [dayOpeningHours]="hour.value.dayOpeningHours"
                            [isBold]="+hour.key == currentDay"
                        />
                    }
                </div>
            </div>
        </div>
    </div>
</div>
